export default __webpack_public_path__ + "images/a361b7f3303d08a0b871e54a7fde30de-upgrade-arrow.svg";